module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescir2-8a1ae416d877c66eeaeabe852ec26bf3.jpg";